import getPublishingStatus from './publishing-status';

export default {
  getPublishingStatus,
};
